export default {
  typography: {
    allVariants: {
      fontFamily: '"MuseoSans", Helvetica, Arial, sans-serif',
    },
    button: {
      textTransform: 'none',
      lineHeight: 'normal',
    },
  },
}
